var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIvanprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ivan_profile",
    "data-name": "Ivan profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 917 920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 6px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000c19;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #754b19;\n      }\n\n      .cls-4 {\n        fill: #06b6db;\n      }\n\n      .cls-5 {\n        fill: #182c3d;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        stroke-width: 5px;\n      }\n\n      .cls-7 {\n        fill: #000c19;\n      }\n\n      .cls-8 {\n        fill: #ffe1b6;\n      }\n\n      .cls-9 {\n        fill: #935816;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 462.17,
    cy: 459.17,
    r: 447.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 462.17,
    cy: 459.17,
    r: 447.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.93,938.39s-44.77-343.97,203.15-339.68c252.3,4.37,191.14,342.96,191.14,342.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "skin",
    className: "cls-8",
    d: "M636.47,380.27c-1.57-5.08-5.46-16.38-16.38-17.48-6.34-.63-16.4,11.05-18.57,15.29-6.19-65.8-24.06-203.29-132.16-199.88-103.76,3.28-144.13,199.09-144.17,198.78-1.09-7.65-4.37-17.48-14.2-17.48-10.98,0-14,14.9-16.38,19.66-3.28,6.55-6.22,22.31-4.37,27.31,10.92,29.49,18.57,48.06,32.77,54.61,7.08,3.27,16.78-1.15,17.48-5.46,0,0,35.65,101.01,83.01,115.77l2.18,99.39,86.29,5.46v-101.58c44.95-16.49,60.02-62.08,76.46-120.14,0,0,6.55,9.83,18.57,8.74,12.4-1.13,21.84-39.32,32.77-66.63,1.98-4.94-1.7-11.3-3.28-16.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("g", {
    id: "collar"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "423.49 602.26 468.99 673.56 373.65 697.61 423.49 602.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "511.96 605.26 468.69 673.65 554.73 699.79 511.96 605.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.57,398.83l23.78,91.19,33.47,32.5s23.83-54.88,70.12-56.52c46.29-1.64,62.92,56.52,62.92,56.52l33.66-36.1,26.16-96.33,13.11-3.28s-21.49,146.62-31.5,157.41c-10,10.79-57.81,37.79-104.35,39.03-46.55,1.25-108.88-46.53-108.88-46.53l-30.51-128.07,12.01-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M414.08,545.03s13.58-51.84,53-50.96c39.42,.88,47.07,53.31,47.07,53.31l-36.04,10.92,3.28-25.12h-31.67l1.09,22.94-36.72-11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M331.74,413.03s-21.84-124.51,3.3-169.69c15.8-28.38,34.89-87.94,81.33-89.1,46.44-1.16,40.11-5.53,50.81-13.17,15.29-10.92,98.55-4.09,101.58,26.21,2.18,21.84,19.32,19.55,26.21,21.84,13.11,4.37,20.87,28.31,33.86,45.87,18.57,25.12-32.77,184.02-29.49,182.4l-8.74-10.92s2.18-149.63-24.03-163.83c-23.86-12.92-76.71,9.28-90.65,10.92-18.57,2.18-85.19-37.14-114.68-21.84-30.6,15.87-31.67,135-25.12,166.02,6.55,31.02-4.37,15.29-4.37,15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.74,421.77s-25.12-136.53-9.83-183.49c10.06-30.89,27.83-65.47,74.27-66.63,46.44-1.16,62.48-31.68,73.18-39.32,15.29-10.92,87.76,13.29,89.56,43.69,1.8,30.4,40.44,24.12,46.97,27.31,6.53,3.19,5.28,14.78,13.89,34.91,14.5,33.9-23.73,180.79-20.45,179.16l-8.74-10.92s-9.83-149.63-36.04-163.83c-23.86-12.92-70.16,27.85-84.1,29.49-18.57,2.18-61.16-43.69-90.65-28.4-30.6,15.87-43.68,127.36-37.14,158.37,6.55,31.02-10.92,19.66-10.92,19.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 409.02,
    cy: 381.63,
    rx: 16.66,
    ry: 11.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 523.7,
    cy: 381.63,
    rx: 16.66,
    ry: 11.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "glasses"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 354.13,
    y: 355.69,
    width: 100.48,
    height: 51.33,
    rx: 6.06,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 476.46,
    y: 355.69,
    width: 100.48,
    height: 51.33,
    rx: 6.06,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 454.62,
    y1: 381.91,
    x2: 476.46,
    y2: 381.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "578.58 375.35 614.63 358.42 612.44 367.16 578.58 385.73 578.58 375.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "353.59 375.9 323 363.88 325.19 378.08 354.68 385.73 353.59 375.9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvanprofile);
export default __webpack_public_path__ + "static/media/Ivan profile.b9c5a872396b4134e6b6b50ebc79e479.svg";
export { ForwardRef as ReactComponent };